import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { ChecklistService } from './services/checklist.service';
import { IChecklist } from './interfaces/checklist.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  providers: [MessageService]
})
export class ChecklistComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedChecklist: IChecklist | null = null;
  dataSource: IChecklist[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'numAct', header: 'N° Acta', sortable: true },
    { field: 'descripcion', header: 'Descripción', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private checklistService: ChecklistService,
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.checklistService.getChecklists().subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los checklists'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar checklists:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los checklists'
        });
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedChecklist = null;
    this.displayDialog = true;
  }

  openUpdate(row: IChecklist): void {
    this.loading = true;
    this.checklistService.getChecklistDetail(row.numAct.toString()).subscribe({
      next: (response) => {
        if (response.success && response.data.length > 0) {
          this.selectedChecklist = response.data[0];
          this.displayDialog = true;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo cargar el detalle del checklist'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar detalle del checklist:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar el detalle del checklist'
        });
        this.loading = false;
      }
    });
  }

  openDelete(row: IChecklist): void {
    this.deleteChecklist(row.numAct);
  }

  onDialogClosed(): void {
    this.selectedChecklist = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }

  deleteChecklist(numAct: number): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este checklist?',
      icon: 'warning',
      showCancelButton: true,
      iconColor: '#d33',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.checklistService.deleteChecklist(numAct.toString()).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Checklist eliminado exitosamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: response.data?.error || 'No se pudo eliminar el checklist'
              });
            }
            this.loading = false;
          },
          error: (error) => {
            console.error('Error al eliminar checklist:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el checklist'
            });
            this.loading = false;
          }
        });
      }
    });
  }
} 